import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { ListItem, ListItemIcon } from '@mui/material';
import clsx from 'clsx';
import Tooltip from '../../../Common/Tooltip';

const MenuItem = ({ item, listItemClasses }) => {
  return (
    <NavLink to={item.path} activeClassName="active">
      <Tooltip
        title={item.name}
        placement="left"
        arrow
      >
        <ListItem className={clsx(listItemClasses, 'justify-center w-full py-2 rounded-l')} button disableGutters>
          <ListItemIcon className="w-full flex-row justify-center items-center text-gray-900">
            <item.icon className="text-gray-200" />
          </ListItemIcon>
        </ListItem>
      </Tooltip>

    </NavLink>
  );
};

MenuItem.propTypes = {
  item: PropTypes.shape({
    path: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  listItemClasses: PropTypes.string.isRequired,
};

export default MenuItem;
